module.exports = __webpack_public_path__ + "static/roleimg-d5abbc2390bb1f0d2f9586e08051bb98.png";